import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

const Badges = ({ colors, status, children, containerClassName }) => (
  <div
    className={cn(
      'text-xs font-semibold rounded-[3px] tracking-wider text-center py-[2px] px-[14px] text-white',
      colors[status],
      containerClassName,
    )}
  >
    {!children?.length ? status : children}
  </div>
);

Badges.defaultProps = {
  colors: {
    SUCCESS: 'bg-success',
    APPROVED: 'bg-success',
    ACTIVE: 'bg-success',
    PAID: 'bg-success',
    SENT: 'bg-success',
    PROCESSED: 'bg-success',
    PENDING: 'bg-warning',
    PROCESSING: 'bg-warning',
    INACTIVE: 'bg-danger',
    REJECTED: 'bg-danger',
    FAILED: 'bg-danger',
    DRAFT: 'bg-gray-200',
    'NO REQUIREMENTS PASSED': 'bg-secondary-500',
    BAN: 'bg-danger',
    UNBAN: 'bg-warning',
    INSUFFICIENT: 'bg-danger',
  },
  status: 'APPROVED',
  containerClassName: '',
  children: '',
};

Badges.propTypes = {
  colors: PropTypes.instanceOf(Object),
  containerClassName: PropTypes.string,
  status: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
};

export default Badges;
